import { ApolloClient, ApolloLink, from } from "@apollo/client";

import {
  authMiddleware,
  cache,
  errorMiddleWare,
  getHttpLink,
  getRestLink,
} from "@stadium/services/apollo-client/utils";

const emptyArr = [];

const getLinkArguments = ({
  type = "auth",
  workspaceLink,
  authLink,
  middlewares,
  token,
  defaultUri,
  endpoints,
  customHeaders,
  restEndpoint,
  user = {},
}) => {
  const args: ApolloLink[] = [];

  if (type === "auth") {
    if (workspaceLink) {
      args.push(workspaceLink);
    }
    if (authLink) {
      args.push(authLink);
    } else if (!workspaceLink && token) {
      args.push(authMiddleware(token));
    }
  }

  args.push(...middlewares, errorMiddleWare(user));

  if (restEndpoint) {
    args.push(getRestLink({ customHeaders, restEndpoint }));
  }

  args.push(getHttpLink({ default: defaultUri, endpoints, customHeaders }));

  return args;
};

export const getUnauthLink = ({
  middlewares = emptyArr,
  defaultUri,
  endpoints,
  customHeaders,
  restEndpoint,
}) =>
  from(
    getLinkArguments({
      type: "unauth",
      middlewares,
      defaultUri,
      endpoints,
      customHeaders,
      restEndpoint,
    }),
  );

export const setApolloAuthLinkWithConfig = ({
  middlewares = emptyArr,
  workspaceLink,
  authLink,
  defaultUri,
  endpoints,
  customHeaders,
  restEndpoint,
  user,
}) =>
  from(
    getLinkArguments({
      type: "auth",
      workspaceLink,
      authLink,
      middlewares,
      defaultUri,
      endpoints,
      customHeaders,
      restEndpoint,
      user,
    }),
  );

export const getApolloAuthLink = ({
  middlewares = emptyArr,
  token,
  defaultUri,
  endpoints,
  customHeaders,
  restEndpoint,
}) =>
  from(
    getLinkArguments({
      type: "auth",
      middlewares,
      token,
      defaultUri,
      endpoints,
      customHeaders,
      restEndpoint,
    }),
  );

export const getClient = (() => {
  let client: ApolloClient<any> = null;
  return (clientOptions) => {
    const {
      defaultUri,
      endpoints,
      customHeaders,
      restEndpoint,
      defaultOptions = {},
    } = clientOptions;
    if (!client) {
      client = new ApolloClient({
        cache,
        connectToDevTools: true,
        link: getUnauthLink({ defaultUri, endpoints, customHeaders, restEndpoint }),
        defaultOptions,
      });
    }
    return client;
  };
})();
